module.exports = __webpack_public_path__ + "img/3.67b3e2e3.jpg";